export default "__VITE_ASSET__Dx_vMh1I__"